var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ArrowMenu',{attrs:{"menu":_vm.moduli}}),(_vm.default_lang || _vm.isNewCampaign)?_c('router-view',{key:_vm.$route.path,on:{"update-company":_vm.setCampaignLanguages}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }